import { tnlmBaseUrl } from "./constants";

export function generateTNLMUrl(env) {
  return env === "DEMO" ?
    tnlmBaseUrl?.demo :
      env === "PRODUCTION" ? 
    tnlmBaseUrl?.production :
    tnlmBaseUrl?.staging
}